module.exports = __webpack_public_path__ + "static/media/eth-blue.78b9627f.svg";